module.exports = __webpack_public_path__ + "img/logo_2020.5f9a4aeb.svg";